// extracted by mini-css-extract-plugin
export default {"sm":"600px","md":"768px","lg":"992px","xl":"1200px","xxl":"1500px","xxxl":"1920px"};